import { Button, type ButtonProps } from "$components/button/button";
import React from "react";
import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

/** @deprecated possible-component */
export const SubmitButton: FC<ButtonProps> = (props) => {
  const { formState } = useFormContext();

  return (
    <Button type="submit" loading={formState.isSubmitting} {...props}>
      {props.children ?? (
        <FormattedMessage id="submitButton" defaultMessage="Submit" />
      )}
    </Button>
  );
};

/**
 * @deprecated Use a `SubmitButton` instead - we don't want to disable buttons when the form is invalid anymore,
 * as a nicer UX is attempt submit and be scrolled to the offending fields via the native browser form api.
 */
export const ValidatingSubmitButton = (
  props: ButtonProps,
): React.ReactElement => {
  const { formState } = useFormContext();

  const { isValid, isSubmitting } = formState;

  return (
    <Button
      loading={isSubmitting}
      disabled={!isValid || isSubmitting}
      type="submit"
      {...props}
    />
  );
};
